import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "join", pure: false })
export class JoinPipe implements PipeTransform {
    transform(input: any[], delimiter = ", "): string {
        if (input !== undefined) {
            return input.join(delimiter);
        } else {
            return "";
        }
    }
}
